var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-layers',[_c('font-awesome-icon',{attrs:{"icon":"circle"}}),_c('font-awesome-icon',{style:({ color: 'white' }),attrs:{"icon":"plus","transform":"shrink-6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }